module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-regular.8ace4507.woff";